import { usePageTracking } from '@utils/hooks'

const PageTracker = () => {
	usePageTracking()

	return null
}

export default PageTracker
